import { Link, Typography, Tooltip, Box, IconButton, Button } from '@material-ui/core'

import EditIcon from '@material-ui/icons/Edit'

import { SpacedGroup, Label } from 'UI/Components'
import { CtaDialog } from 'UI/Components/VideoEditor/hoverControls'

import { TextOverflow } from '@guidde-co/shared.text-overflow.text-overflow'

import { ReactComponent as CTAIcon } from 'assets/icons/cta-icon.svg'

import { useBoolean } from 'hooks'
import { QuickGuidePlaybookType } from 'app/types'
import { uiId } from 'modules'

type Props = {
    playbook: QuickGuidePlaybookType
    revalidate: (data?: QuickGuidePlaybookType) => void
}

export const QGCallToActionButton = ({ playbook, revalidate }: Props) => {
    const open = useBoolean()

    return (
        <Box>
            <Label label="Action Item" />
            <Box mt={1} />
            {playbook.cta ? (
                <Box bgcolor="#F5F5F5" p="5px" id={uiId('playbook-action-item')}>
                    <SpacedGroup>
                        <Box
                            borderRadius={4}
                            bgcolor="#F5F5F5"
                            width={40}
                            minWidth={40}
                            height={40}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {playbook.cta.image && (
                                <img
                                    src={playbook.cta.image}
                                    width="100%"
                                    height="100%"
                                    style={{ objectFit: 'cover' }}
                                />
                            )}
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            flexWrap="nowrap"
                            width="100%"
                            justifyContent="space-between"
                        >
                            <Box>
                                <Typography style={{ fontWeight: 500, fontSize: 14 }}>
                                    {playbook.cta.text.value}
                                </Typography>
                                <Tooltip title={playbook.cta.link}>
                                    <Box>
                                        <TextOverflow lineClamp={1}>
                                            <Link
                                                target="_blank"
                                                href={playbook.cta.link}
                                                color="secondary"
                                                style={{ fontWeight: 500, fontSize: 14 }}
                                            >
                                                {playbook.cta.link}
                                            </Link>
                                        </TextOverflow>
                                    </Box>
                                </Tooltip>
                            </Box>
                            <IconButton
                                data-cy="cta-edit-button"
                                size="small"
                                onClick={open.setTrue}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </SpacedGroup>
                </Box>
            ) : (
                <>
                    <SpacedGroup>
                        <Box
                            bgcolor="#F5F5F5"
                            borderRadius="50%"
                            width={40}
                            height={40}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <CTAIcon />
                        </Box>
                        <Box>
                            <Typography style={{ fontWeight: 500, fontSize: 14 }}>
                                Action item
                            </Typography>
                            <Typography color="textSecondary" style={{ fontSize: 14 }}>
                                shows up inside your video
                            </Typography>
                        </Box>
                    </SpacedGroup>
                    <Box mt={1} />
                    <Button color="secondary" variant="text" onClick={open.setTrue}>
                        + ADD ACTION ITEM
                    </Button>
                </>
            )}
            {open.isTrue && (
                <CtaDialog
                    lastItemLabel="Last step"
                    isOpen={true}
                    callback={({ cta }) => revalidate({ ...playbook, cta })}
                    onClose={open.setFalse}
                    playbook={playbook}
                />
            )}
        </Box>
    )
}
